import { DynamicLottie } from '@/components/common/DynamicLottie';
import { PageContainer } from '@/components/common/PageContainer';

export function Landing() {
  return (
    <PageContainer>
      <PageContainer.GhostNavigationBar />
      <PageContainer.Content>
        <DynamicLottie
          id={'landing'}
          style={{ width: 120, marginTop: 'calc(191px - 64px)', marginBottom: 8 }}
          play
          loop={true} />
        <section className={'flex flex-col items-center py-5 px-10'}>
          <h1 className={'s24 b text-black mb-2'}>스윙 앱으로 이동할게요</h1>
          <p className={'s14 r text-g-600'}>잠시만 기다려주세요</p>
        </section>
      </PageContainer.Content>
    </PageContainer>
  );
}